import { InsightsFilterFieldMap } from 'respona_api/generated/analytics_pb';

export const InsightsTypeMapper: InsightsFilterFieldMap = {
  DROPDOWN_INSIGHT_WORKSPACE_ID: 0,
  DROPDOWN_INSIGHT_CAMPAIGN_ID: 1,
  DROPDOWN_INSIGHT_USER_ID: 2,
  DROPDOWN_INSIGHT_MAILBOX_ACCOUNT_ID: 3,
  DROPDOWN_INSIGHT_CAMPAIGN_TEMPLATE_ID: 4,
};
